import { getEventFromValue } from "shared/topchef.types";
import { useTranslation } from "react-i18next";

export interface EventTypeRendererProps {
  eventValue: string | ''
}

const EventTypeRenderer = (props: EventTypeRendererProps) => {
    const { t } = useTranslation();
    const eventType = getEventFromValue(props.eventValue);
    return (
      <div>
        {t(eventType.label)}
      </div>
    );

  };

  export default EventTypeRenderer;
